import { graphClient } from "../graph-client";
import { SIGNUP } from "./gql";
import { Login } from "./types";

class AuthService {
  async login(params: Login.Input) {
    const client = graphClient;

    const request = await client.request<Login.Output>(SIGNUP, {
      ...params,
      // login não cria conta: número desconhecido volta user_not_found
      loginOnly: true,
    });

    return request?.signup;
  }
}

export const authService = new AuthService();
